import { Form, Switch } from "antd";
import type { FormInstance } from "antd";
import { Customer } from "@lib/types/Customer";
import { customerSchema as yupSchema } from "@lib/schemas/customer";
import { createYupSync } from "@lib/helpers/TableHelper";
import useIntl from "react-intl/lib/src/components/useIntl";
import { useCustomerQueries } from "@lib/apiQueries";

type Props = {
  form: FormInstance<Customer>;
  customer: Customer;
  initialValues: Customer;
};

const AppConfig: React.FC<Props> = ({
  form: _form,
  customer,
  initialValues: _initialValues,
}) => {
  const { messages } = useIntl();

  const { customerNotifyStatusQuery } = useCustomerQueries({
    id: customer?.id,
    messages,
    queryKey: ["customer", customer?.id],
  });

  return (
    <div style={{ padding: "24px" }}>
      <Form.Item
        name="isWhatsappPlatform"
        label={messages["common.whatsappPlatform"] as string}
        extra={messages["common.whatsappPlatform.info"] as string}
        rules={[createYupSync({ schema: yupSchema })]}
        valuePropName="checked"
      >
        <Switch
          checkedChildren={messages["common.enabled"] as string}
          unCheckedChildren={messages["common.disabled"] as string}
        />
      </Form.Item>

      <Form.Item
        name="enabled"
        label={messages["common.accountStatus"] as string}
        extra={messages["common.accountStatus.info"] as string}
        rules={[createYupSync({ schema: yupSchema })]}
        valuePropName="checked"
      >
        <Switch
          checkedChildren={messages["common.enabled"] as string}
          unCheckedChildren={messages["common.disabled"] as string}
        />
      </Form.Item>

      <Form.Item
        label={messages["common.appStatus"] as string}
        extra={messages["common.appStatus.info"] as string}
        rules={[createYupSync({ schema: yupSchema })]}
      >
        <Switch
          checkedChildren={messages["common.enabled"] as string}
          unCheckedChildren={messages["common.disabled"] as string}
          checked={!customer?.isClosed}
          onChange={async (checked) => {
            if (!customer?.id) return;
            await customerNotifyStatusQuery.mutateAsync({
              id: customer.id,
              shouldClose: !checked,
            });
          }}
        />
      </Form.Item>

      <Form.Item
        name="isAutoBtcEnabled"
        label={messages["common.sendByteStatus"] as string}
        extra={messages["common.sendByteStatus.info"] as string}
        rules={[createYupSync({ schema: yupSchema })]}
        valuePropName="checked"
      >
        <Switch
          checkedChildren={messages["common.enabled"] as string}
          unCheckedChildren={messages["common.disabled"] as string}
        />
      </Form.Item>

      <Form.Item
        name="isMarketPlaceEnabled"
        label={messages["common.marketPlaceStatus"] as string}
        extra={messages["common.marketPlaceStatus.info"] as string}
        rules={[createYupSync({ schema: yupSchema })]}
        valuePropName="checked"
      >
        <Switch
          checkedChildren={messages["common.enabled"] as string}
          unCheckedChildren={messages["common.disabled"] as string}
        />
      </Form.Item>

      {/* Future app config fields will be added here */}
    </div>
  );
};

export default AppConfig;
